<template lang="pug">
	
	.black-beetles
		.presentation
			p.text.text-1(v-html="translate('badass.badass_album_2')")

			.mobile-image(v-if="isMobile")
				responsive-image(src="assets/images/mlk.png" width="720" height="720")

			parallax-image(v-if="!isMobile" :src="mlkImg").image-1
			
			parallax-image(v-if="!isMobile" :src="posterImg").image-2


		.black-beetles-quote
			blockquote(v-html="translate('badass.quote_2')")
			p.quote-author(v-html="translate('badass.author_2')")
			p.quote-translation(v-html="translate('badass.traduction_2')")

		.mobile-image(v-if="isMobile")
			responsive-image(src="assets/images/joey-bada-ft-bj-the-chicago-kid-like-me-official-music-video.png" width="720" height="306")

</template>

<script>
		
	import Vue from 'vue'
	import Component from 'vue-class-component'
	import { TweenMax } from 'gsap'
	import Scrollable from '~abstracts/scrollable'
	import {GlobalMixin} from '../../../mixins/mixins'
	import ResponsiveImage from '~components/responsive-image.vue'
	import Globals from '~utils/Globals'
	import ParallaxImage from '~components/parallax-image.vue'
	import MLK from 'assets/images/mlk.png'
	import poster from 'assets/images/joey-bada-ft-bj-the-chicago-kid-like-me-official-music-video.png'
	
  	@Component({
		name: 'BlackBeetles',
		components: {ResponsiveImage,ParallaxImage},
		mixins:[GlobalMixin],
		data: function () {
			return {
				mlkImg: MLK,
				posterImg: poster
			}
		}
	})

	class BlackBeetles extends Scrollable {

		mounted () {
			super.mounted()
			
			this._dom()
		}

		init () {
			super.init()

		}

		_bind () {
			super._bind()
		}

		_dom () {
			this.$image1 = this.$el.querySelector('.image-1')
			this.$image2 = this.$el.querySelector('.image-2')
			this.$text1 = this.$el.querySelector('.text-1')
		}

		initTimeline () {
			super.initTimeline()

			this.total = this.boundsAnim.bottom - this.boundsAnim.top
			const dur = window.innerHeight/this.total

			this.tl.fromTo(this.$text1,dur,
			{
				y: Globals.responsiveHeight(-150)
			},
			{
				y:Globals.responsiveHeight(0)
			},0)

			this.tl.to(this.$text1, dur,{y:40},dur)

			// this.tl.fromTo(this.$image2,1,{y:Globals.responsiveHeight(100)},{y:Globals.responsiveHeight(-20), delay:.3},0)
		}

		raf (y) {
			super.raf(y)	
		}

		_points () {

		}

		_resize () {
			super._resize()

			this.boundsAnim = {
				top: this.bounds.top - window.innerHeight,
				bottom: this.bounds.top + window.innerHeight
			}


			this.initTimeline()
			this._points()
		}

		_on () {
			super._on()
		}

		_off () {
			super._off()
			
		}

	}

	export default BlackBeetles

</script>


<style lang="stylus">
	
	@import '../../../theme/utils'
	@import '../../../theme/variables'
	
	.black-beetles
		width 100%
		position relative
		padding-bottom 50px
		
		.presentation
			position relative
			width 100%
			padding-top 15%
			padding-bottom 25%

			+break(xs)
				padding-top 50px
				padding-bottom 0px

			.text
				color #fff
				font-family $FONT_THIRDLY
				font-weight 700
				font-size em(20px)
				line-height em(50px,20px)
				width 30%
				margin-left 55%
				position relative
				z-index 80

				+break(xs)
					width 100%
					margin-left 0

				span,a
					text-decoration underline
					font-family $FONT_THIRDLY
					font-weight 700
					color #fff
		
		.wrap-image,
		.parallax-image
			position absolute

			&.image-1
				top 0
				left 0
				width 50%

			&.image-2
				bottom 0
				right 5%
				width 50%

			img
				width 100%

		.mobile-image
			width 100%
			margin 20px 0px
		
		.black-beetles-quote
			width 100%
			margin-top 50px
			text-align center
			position relative
			z-index 80

			+break(xs)
				margin-top 50px

			blockquote
				font-size em(40px)
				line-height em(50px,40px)
				color #fff
				font-family $FONT_PRIMARY
				max-width 1200px
				width 100%
				margin auto

			.quote-author
				font-size em(20px)
				line-height em(50px,20px)
				text-transform uppercase
				font-family $FONT_SECONDARY
				font-weight 300
				color #fff
				letter-spacing .15em
				margin-top 15px
			
			.quote-translation
				max-width 570px
				margin auto
				margin-top 20px
				color #fff
				font-size 15px
				line-height em(21px,15px)
				letter-spacing .15em
				font-family $FONT_SECONDARY
				font-weight 300
				text-transform uppercase
	
</style>


// WEBPACK FOOTER //
// black-beetles.vue?5e6a7133